<app-page-meta pageTitle="finzy - Investment Application"></app-page-meta>
<app-header></app-header>
<div class="row mainrow">
    <div class="col-sm-4 leftdiv">
        <app-lenderleftdiv></app-lenderleftdiv>
    </div>
    <div class="col-sm-8 rightdiv">
        <div class="mobileleftdiv">
            <app-lender-registration-progress-bar></app-lender-registration-progress-bar>
        </div>
        <div class="rightinnerdiv">
            <form #d="ngForm" (ngSubmit)="submitOtpVerification(d.value)" (keydown.enter)="$event.preventDefault()">
                <p class="headtxt">We’ll need a phone number to reach you on</p>

                <p class="txt1">Your current mobile number</p>
                <mat-form-field style="width: 100%">
                    <span matPrefix>+91&nbsp;</span>
                    <input matInput placeholder="You will need this to login and for updates" [(ngModel)]="phoneNumber"
                           [readonly]="isReadonly" maxlength="10" name="phoneno" type="text"
                           (keyup)="onPhoneInput($event)"
                           required [disabled]="phoneNumberDisabled">
                    <button mat-stroked-button matSuffix class="btn-input-suffix" (click)="sendOtp();
analyticsTracker.trackButtonClick('Lender Phone verification', otpButton)"
                            [disabled]="fieldDisabledTag" type="button">{{otpButton}}
                    </button>
                </mat-form-field>
                <span class="errormsg" *ngIf="mobileError">{{mobileErrorMsg}}</span>

                <div *ngIf="showOtp">
                    <p class="txt1">Enter OTP number</p>
                    <mat-form-field style="width: 100%">
                        <input matInput placeholder="Please enter the OTP you have received on your phone"
                               [(ngModel)]="otp"
                               name="otp" required type="password" maxlength="6" [disabled]="otpDisabled">
                    </mat-form-field>
                    <span class="errormsg2" *ngIf="mobileOtpError">Please provide a valid OTP</span>
                </div>

                <div *ngIf="shouldShowConsentCheckboxes()">
                    <p class="bottom">
                        <mat-checkbox [disabled]="!shouldShowConsentCheckboxes()" [(ngModel)]="check1" name="check1"
                                      required
                                      [checked]="termsChecked" title="Please accept terms to proceed"></mat-checkbox>&nbsp;&nbsp;
                        I
                        agree to the <a [routerLink]="['/terms']" target="_blank" class="terms">Terms and conditions</a>
                    </p>

                    <p class="bottom">
                        <mat-checkbox [disabled]="!shouldShowConsentCheckboxes()" [(ngModel)]="check2" name="check2"
                                      required
                                      [checked]="termsChecked" title="Please accept terms to proceed"></mat-checkbox>&nbsp;&nbsp;
                        I
                        declare that my annual income is more than Rs 3 lakhs or my networth is more than Rs 10 lakhs
                    </p>

                </div>
                <span class="errormsg2" *ngIf="checkError">Please accept terms to proceed</span>

                <div class="row buttondiv">
                    <div class="col-sm-6 backbtn">
                        <button mat-stroked-button class="button-back primary" *ngIf="disableBtn" [routerLink]="['../pan-verification']" type="button"><i
                                class="material-icons">arrow_back</i>&nbsp;&nbsp;&nbsp; BACK
                        </button>
                    </div>
                    <div class="col-sm-6 moveright">
                        <app-forward-button class="button-forward" [isLoading]="loader" (click)="analyticsTracker.trackButtonClick('Lender Phone Verification', 'NEXT')">
                            NEXT
                        </app-forward-button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>


<app-footer></app-footer>






